module.exports = __webpack_public_path__ + "img/ic-dinners-white.11140bd4.svg";